// extracted by mini-css-extract-plugin
export default {"statsContainer":"tBTGi5Rowr7T4hUMrMiv"};